import React from 'react';

import InsertImagePanel from './InsertImage';

// TODO: skipped support until using. refactoring - to latest menu changes.

const ImageTab = (props) => {
  return <InsertImagePanel props={props}/>
};

export default React.memo(ImageTab);
